"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bar = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

var wrapper = function wrapper(width) {
  return react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  height: 4px;\n  border-radius: 4px;\n  background-color: var(--gray-200);\n"])), width);
};

exports.wrapper = wrapper;

var bar = function bar(ratio, color) {
  return react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ", "%;\n  height: 4px;\n  border-radius: 4px;\n  background-color: ", ";\n"])), ratio, color === 'GRAY' ? 'var(--gray-500)' : 'var(--gray-400)');
};

exports.bar = bar;